import type { HTMLAttributes } from "react";

import { cn, type VariantProps } from "../utils";
import { ncTagGroupClasses } from "./nc-tag-group";

type NcTagListProps = HTMLAttributes<HTMLUListElement>;

const NcTagList = ({ className, ...props }: NcTagListProps) => {
  return <ul data-nc="NcTagList" className={cn(ncTagGroupClasses.list, className)} {...props} />;
};

type NcTagListItemProps = HTMLAttributes<HTMLLIElement>;

const Item = ({ ...props }: NcTagListItemProps) => {
  return <li data-nc="NcTagList.Item" {...props} />;
};

type NcTagListTagProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof ncTagGroupClasses.tag>;

const Tag = ({ children, variant = "default", className, ...props }: NcTagListTagProps) => {
  return (
    <span
      data-nc="NcTagList.Tag"
      className={cn(ncTagGroupClasses.tag({ variant }), className)}
      {...props}
    >
      <span className={ncTagGroupClasses.tagContent}>{children}</span>
    </span>
  );
};

NcTagList.Item = Item;
NcTagList.Tag = Tag;

export { NcTagList };
